import * as Sentry from '@sentry/vue';

export function sentryInit(app, router) {
  Sentry.init({
    app,
    environment: import.meta.env.VITE_SENTRY_ENV,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    debug: import.meta.env.VITE_SENTRY_ENV !== 'production',
    tracingOptions: {
      trackComponents: true,
    },
    // Vue specific
    logErrors: import.meta.env.VITE_SENTRY_ENV === 'test',
    attachProps: true,
    attachStacktrace: true,
    // Performance Monitoring
    tracesSampleRate: import.meta.env.VITE_SENTRY_ENV === 'production' ? 0.2 : 1,
    // Session Replay
    replaysSessionSampleRate: import.meta.env.VITE_SENTRY_ENV === 'production' ? 0.1 : 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
